"use client"

import { Suspense, useEffect, useRef } from "react"
import { usePathname, useSearchParams } from "next/navigation"
import { YANDEX_COUNTER_ID } from "@lib/analytics-client-id"

/** Sends a Yandex.Metrika hit on client-side route changes (SPA navigation). */
function MetrikaPageViewTracker() {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  // The counter sends the first hit itself on init — skip the initial render.
  const isFirstRender = useRef(true)

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }
    const search = searchParams.toString()
    const url = search ? `${pathname}?${search}` : pathname
    if (!YANDEX_COUNTER_ID) return
    try {
      window.ym?.(YANDEX_COUNTER_ID, "hit", url)
    } catch {
      // The counter may still be loading via GTM — a missed hit is acceptable.
    }
  }, [pathname, searchParams])

  return null
}

export default function MetrikaPageView() {
  return (
    <Suspense fallback={null}>
      <MetrikaPageViewTracker />
    </Suspense>
  )
}
